import React from 'react';
import "./style.css";

function About(){
    return(
        <p className="paraone">The wolf is my favorite animal. 
        Why? For a few reasons. First and foremost, it
        has a beautiful and majestic look that makes it immediately recognizable. Another reason
        is their unmistakable howl. In wilderness movies, when you hear a howl, you know there are wolves around.
        Finally, it's their connection to family. The wolf is known for its bond with a pack.  
         </p>


    );
}

export default About;